import React from "react";
import "../styles/CasosExitoContenidoAds.scss";

const casos = [
  {
    nombre: "Negocio de Venta de Productos",
    resultado: "Más pedidos y mensajes constantes",
    descripcion:
      "Activamos campañas por producto para generar mensajes diarios y mejorar la conversión.",
    bullets: [
      "Campañas por producto/temporada",
      "Creativos tipo catálogo + oferta",
    ],
  },
  {
    nombre: "Construcción, Remodelación y Servicios del Hogar",
    resultado: "Prospectos de la zona listos para cotizar",
    descripcion:
      "Trabajamos campañas segmentadas por colonia/ciudad y contenido que demuestra trabajos reales.",
    bullets: [
      "Segmentación por ubicación",
      "Contenido con prueba social (trabajos reales)",
    ],
  },
  {
    nombre: "Servicios Profesionales",
    resultado: "Más confianza y agenda más llena",
    descripcion:
      "Ideal para abogados, contadores, ingenieros y especialistas.",
    bullets: [
      "Contenido educativo que posiciona",
      "Anuncios con enfoque a consulta/cita",
    ],
  },
];

const CasosExitoContenidoAds = () => {
  return (
    <section className="ovit-casos" id="casos">
      <div className="ovit-casos__container">
        <header className="ovit-casos__header">
          <h2 className="ovit-casos__title">
            Casos de <span>Éxito</span>
          </h2>
          <p className="ovit-casos__subtitle">
            Estrategias completas que generan mensajes, prospectos y ventas (no solo “posts bonitos”).
          </p>
        </header>

        <div className="ovit-casos__grid">
          {casos.map((c) => (
            <article className="ovit-casoCard" key={c.nombre}>
              <div className="ovit-casoCard__top">
                <div className="ovit-casoCard__name">{c.nombre}</div>
                <div className="ovit-casoCard__resultado">{c.resultado}</div>
              </div>

              <p className="ovit-casoCard__desc">{c.descripcion}</p>

              <ul className="ovit-casoCard__list">
                {c.bullets.map((b) => (
                  <li key={b}>
                    <span className="ovit-casoCard__check">✓</span>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Social proof extra */}
        <div className="ovit-casos__proof">
          <div className="ovit-casos__proofCard">
            <div className="ovit-casos__proofBig">+100</div>
            <div className="ovit-casos__proofText">
              Clientes satisfechos que ya trabajan con nosotros y recomiendan nuestro sistema.
            </div>

            <div className="ovit-casos__proofActions">
              <a className="ovit-casos__btn" href="#planes">
                Ver planes
              </a>
              <a className="ovit-casos__btn ovit-casos__btn--ghost" href="https://wa.me/525588093678?text=Hola,%20me%20interesa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios%20de%20marketing%20digital.%20Quiero%20hacer%20crecer%20mi%20negocio%20y%20generar%20m%C3%A1s%20clientes." target="_blank" rel="noopener noreferrer">
                Hablar por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CasosExitoContenidoAds;